import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CarouselService {

  constructor(private http: HttpClient) { }
  private url = 'https://sea.sep.gob.mx/php/';

  getCarousel(){
    return this.http.get(
      `${this.url}lib_carousel.php`
    );
  }
}
